<ng-container *ngIf="dialog$ | async as dialog">
    <div class="modal-header justify-content-start flex-column">
      <div class="modal-title">Sponsor Group</div>
      <div class="modal-subtitle mt-2">Create new sponsor group.</div>
    </div>
    <div class="modal-body" [formGroup]="sponsorGroup">
      <mdb-form-control class="form-fill" >
        <app-mdbp-input mdbInput formControlName="name"  label='Name'></app-mdbp-input>
        <span class="form-fill-error"  *ngIf="sponsorGroup.controls.name.hasError('required') && sponsorGroup.controls.name.touched">Please provide Name</span>
    </mdb-form-control>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-4 offset-4">
          <button type="button" class="btn btn--paybee btn--transparent btn--md text-center w-100" (click)="close(dialog, false)">Cancel</button>
        </div>
        <div class="col-4">
          <button type="button" class="btn btn--paybee btn--black btn--md text-center w-100" (click)="confirm(dialog, sponsorGroup.value)">Create</button>
        </div>
      </div>
    </div>  
</ng-container>
  